import React from 'react';
import MetricCardComponent from '../../../components/MetricCardComponent';
import { useFavoritePlanMetrics } from '../../../hooks/myFavoritePlan/useFavoritePlanMetrics';

const trendFromVariation = (variation) => {
    if (variation > 0) return 'up';
    if (variation < 0) return 'down';
    return 'same';
};

/**
 * A single dashboard metric card that owns its own backend call. While the
 * request is in flight it shows a skeleton; if the API fails or returns no data
 * it falls back to zeros so the card always renders.
 */
const MetricCard = ({ metric, icon, title, comparisonText }) => {
    const { data, isLoading } = useFavoritePlanMetrics(metric);

    const value = data?.total ?? 0;
    const variation = data?.variation ?? 0;

    return (
        <MetricCardComponent
            loading={isLoading}
            icon={icon}
            title={title}
            value={value}
            delta={`${Math.abs(variation)}%`}
            trend={trendFromVariation(variation)}
            comparisonText={comparisonText}
        />
    );
};

export default React.memo(MetricCard);
